import $ from 'jquery';
import Select from 'blocks/select/select';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaTariffType',
			dom: {
				container: '.js-tariff-type-container',
				close: '.js-tariff-type-close',
				select: '.js-tariff-type-select',
				next: '.js-tariff-type-button-next',
				ok: '.js-tariff-type-button-ok',
				description: '.js-tariff-type-description'
			},
			classes: {
				state: {
					open: 'b-tariff-type_state_open'
				},
				button: {
					disabled: 'b-button_state_disabled',
					hidden: 'b-button_state_hidden'
				},
				description: {
					hidden: 'b-tariff-type__description_hidden'
				}
			},
			quantity: 0,
			mnp: false,
			fields: [],
			tariffType: '',
			TARIFF_TYPE_SNG: 'TARIFF_TYPE_SNG',
			TARIFF_TYPE_B2B: 'TARIFF_TYPE_B2B'
		};

		this.options = $.extend(true, {}, defaults, options);
		this.quantity = this.options.quantity;
		this.mnp = this.options.mnp;
		this.fields = this.options.fields;
		this.tariffType = this.options.tariffType;
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.defaultTariffType = {
			text: 'Выберите одно из значений',
			value: '',
			hidden: true
		};
		this.tariffTypes = [
			{
				text: 'Близкие страны',
				value: this.options.TARIFF_TYPE_SNG
			},
			{
				text: 'Стандартный B2B',
				value: this.options.TARIFF_TYPE_B2B
			}
		];
		return this;
	}

	getDom() {
		this.$container = this.$el.find(this.options.dom.container);
		this.$close = this.$el.find(this.options.dom.close);
		this.$select = this.$el.find(this.options.dom.select);
		this.$select = this.$el.find(this.options.dom.select);
		this.$next = this.$el.find(this.options.dom.next);
		this.$ok = this.$el.find(this.options.dom.ok);
		this.$description = this.$el.find(this.options.dom.description);

		return this;
	}

	onClick(event) {
		const self = this;
		const $target = $(event.target);
		if (!$target.is(self.$container) && !$target.closest(self.$container).length) {
			self.close();
		}
		return self;
	}

	open(data) {
		const {quantity, mnp, fields} = data;

		this.quantity = quantity;
		this.mnp = mnp;
		this.fields = fields;

		this.update();
		this.$el.addClass(this.options.classes.state.open);

		return this;
	}

	close() {
		this.$el.removeClass(this.options.classes.state.open);
		return this;
	}

	update() {
		const {quantity, mnp, fields, tariffType, defaultTariffType} = this;
		const {button, description} = this.options.classes;


		if (tariffType !== defaultTariffType.value) {
			// if (tariffType === this.options.TARIFF_TYPE_SNG) {
			//
			// 	if (quantity > 1) {
			//
			// 		if (mnp && fields.length > 1) {
			// 			this.$description
			// 				.text(`Для тарифа СНГ может быть оформлена только 1 SIM-карта. Пожалуйста, вернитесь назад и выберите только 1 номер для переноса`)
			// 				.removeClass(description.hidden);
			// 			this.$next.addClass(button.hidden);
			// 			this.$ok.removeClass(`${button.hidden} ${button.disabled}`);
			// 			return;
			// 		}
			//
			//
			// 		this.$description
			// 			.text(`Вы выбрали ${quantity} ${this.declOfNum(quantity, ['SIM-карту', 'SIM-карты', 'SIM-карт'])}, для тарифа СНГ будет оформлена только 1 SIM-карта`)
			// 			.removeClass(description.hidden);
			// 		this.$ok.addClass(button.hidden);
			// 		this.$next.removeClass(`${button.hidden} ${button.disabled}`);
			// 		return;
			// 	}
			// }
			this.$ok.addClass(button.hidden);
			this.$next.removeClass(`${button.hidden} ${button.disabled}`);
			this.$description.text('').addClass(description.hidden);
		} else {
			this.$ok.addClass(button.hidden);
			this.$next.removeClass(button.hidden).addClass(button.disabled);
			this.$description.text('').addClass(description.hidden);
		}
	}

	onSelect(event, data) {
		this.tariffType = data.value;
		this.update();
	}

	onNext() {
		this.$window.trigger('yota.connect.tariffType.submit', this.tariffType);
		this.close(); // todo
	}

	renderSelect() {
		const options = [this.defaultTariffType, ...this.tariffTypes];
		this.select = new Select({el: this.$select}).render();
		this.select.setOptions(options);
		this.select.setValue(this.defaultTariffType.value);
	}

	declOfNum(number, titles) {
		const cases = [2, 0, 1, 1, 1, 2];
		return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.renderSelect();

			self.$el.on('click', self.onClick.bind(self));
			self.$close.on('click', self.close.bind(self));
			self.$ok.on('click', self.close.bind(self));
			self.$next.on('click', self.onNext.bind(self));
			self.$select
				.on('yota.select.change', self.onSelect.bind(self));

		}
		return self;
	}
}





// WEBPACK FOOTER //
// ./app/portlets/site/connect/tariff-type/tariff-type.js